var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"style-modifier":"text","data-test-id":"menu-button"},on:{"click":function($event){return _vm.$emit('click-log-out-menu')}}},[_c('div',{staticClass:"log-out-menu"},[_vm._v("...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }